import React from "../../_snowpack/pkg/react.js";
export function Loading(props) {
  const {where} = props;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, "loading ", where);
}
